import { render } from "./ParametrageServices.vue?vue&type=template&id=4cbdd22e&scoped=true"
import script from "./ParametrageServices.vue?vue&type=script&lang=js"
export * from "./ParametrageServices.vue?vue&type=script&lang=js"

import "./ParametrageServices.vue?vue&type=style&index=0&id=4cbdd22e&scoped=true&lang=css"
import "./ParametrageServices.vue?vue&type=style&index=1&id=4cbdd22e&lang=css"

import exportComponent from "/var/www/vhosts/elyosdigital.com/_build/workspace/MySchool/myschool.elyosdigital.com/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4cbdd22e"],['__file',"resources/js/pages/payments/ParametrageServices.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "4cbdd22e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('4cbdd22e', __exports__)) {
    console.log('reload')
    api.reload('4cbdd22e', __exports__)
  }
  
  module.hot.accept("./ParametrageServices.vue?vue&type=template&id=4cbdd22e&scoped=true", () => {
    console.log('re-render')
    api.rerender('4cbdd22e', render)
  })

}


export default __exports__